module.exports = __webpack_public_path__ + "HelveticaNeueLTStd-BlkCnO.otf?48be86a10eda99676362e574e5da6988";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HelveticaNeueLTStd-BlkCnO.otf
// module id = 7
// module chunks = 0